import React from "react";

export function TwoocaTab() {
  return (
    <div className="twooca-tab">
      <div className="note">
        <i className="icon-note" />
        <p>TwooCaアカウント登録・連携は完了済みです。</p>
      </div>
      <div className="twooca-tab-link">
        <a
          href="https://support.gochimeshi.com/s/article/twooca-charge-use"
          target="_blank"
        >
          こどもごちめしTwooCaチャージのご利用方法
        </a>
      </div>
      <div className="twooca-tab-link">
        <a
          href="https://support.gochimeshi.com/s/article/twooca-gochi-unlink"
          target="_blank"
        >
          TwooCaとGOCHIアカウントの連携解除について
        </a>
      </div>
      <div className="twooca-tab-link">
        <a
          href="https://support.gochimeshi.com/s/article/twooca-account-delete"
          target="_blank"
        >
          TwooCaアカウントの削除（退会）について
        </a>
      </div>
    </div>
  );
}
